import React, {Component} from 'react'
import styles from './SortList.css'
import {TypeSortListItem} from "../../constants/consts-prop-types"
import SortListItem from "../../components/SortListItem/SortListItem"
import PropTypes from "prop-types"

class SortList extends Component {
  static propTypes = {
    data: PropTypes.arrayOf(TypeSortListItem),
    selectedSortingId: PropTypes.string,
    onSortChange: PropTypes.func.isRequired,
  }

  render() {
    return (
      <div className={styles.SortList}>
        {this.props.data.map((tag, idx) => (
            <SortListItem
              key={idx}
              data={tag}
              isSelected={this.props.selectedSortingId === tag.id}
              orderBy={this.props.orderBy}
              onSortChange={this.props.onSortChange}
            />
          ))}
      </div>
    )
  }
}

export default SortList



// WEBPACK FOOTER //
// ./src/components/SortList/SortList.js